import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

import { SectionContainer } from 'components/DetailsView/Section';
import { StateHistory } from 'components/DetailsView';
import { TotemLabel } from 'components/TotemLabel';

import { formatDateForDisplay, getExtendedFormattedDatetime } from 'helpers/dateTimes';

import { SupplyOrderDetails } from '../supplyOrderFormValues';

/** Ce qui est arrivé à l'achat : ses changements de statut et ses reports de livraison. */
export const StateHistorySection = ({ supplyOrder }: { supplyOrder: SupplyOrderDetails }) => (
    <SectionContainer title="Historique">
        <div className="grid grid-cols-[repeat(auto-fit,minmax(320px,1fr))] gap-8">
            <StateHistory label="Statuts" records={supplyOrder.stateHistory} />

            <div className="flex flex-col gap-[5px]">
                <TotemLabel>Dates de livraison prévues</TotemLabel>
                {supplyOrder.scheduledDeliveryDateHistory.length ? (
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Mis à jour le</TableHead>
                                <TableHead>Date de livraison prévue</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {[...supplyOrder.scheduledDeliveryDateHistory]
                                .reverse()
                                .map(({ createdAt, scheduledDeliveryDate }, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{getExtendedFormattedDatetime(createdAt)}</TableCell>
                                        <TableCell>{formatDateForDisplay(scheduledDeliveryDate)}</TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                ) : (
                    <p className="text-sm text-muted-foreground">Aucun report de livraison.</p>
                )}
            </div>
        </div>
    </SectionContainer>
);
